import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HeadsetIcon(props: IconProps) {
    return <Icon {...props} iconKey={"headset"}/>
}
